// Report's widgets on the Dashboard (#253). Registered from `./index` at
// bootstrap, like `./locales/register`; the Dashboard renders them by id and
// does not import Report. Contract: `src/lib/dashboard-widgets.tsx`.
//
// `load` stays a dynamic import: Report's charts, services and locales are not
// part of the entry chunk. Keep this file to registrations only.
import { registerDashboardWidget } from '@/lib/dashboard-widgets'

registerDashboardWidget({
    id: 'report.target-revenue',
    load: () => import('./components/DashboardWidgets/TargetRevenue'),
})
registerDashboardWidget({
    id: 'report.revenue-allocation',
    load: () => import('./components/DashboardWidgets/RevenueAllocationWidget'),
})
registerDashboardWidget({
    id: 'report.service-trend',
    load: () => import('./components/DashboardWidgets/ServiceTrendWidget'),
})
registerDashboardWidget({
    id: 'report.cancellation-rate',
    load: () => import('./components/DashboardWidgets/CancellationRateWidget'),
})
registerDashboardWidget({
    id: 'report.conversion-funnel',
    load: () => import('./components/DashboardWidgets/ConversionFunnelWidget'),
})
registerDashboardWidget({
    id: 'report.daily-input',
    load: () => import('./components/DashboardWidgets/DailyInputWidget'),
})
